import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Apiservice {
  apiUrl = environment.apiurl + 'jobWebApi/';
  private userDataSubject = new BehaviorSubject(null);
  constructor(private http: HttpClient) {
    let token = localStorage.getItem('access_token');
    if (token) {
      const decoded = this.decodeJWT(token);
      let obj = {
        // name: decoded.username,
        // image: decoded.image,
        // des: decoded.designation,
        user_id: decoded.id,
        role_type: decoded.role,
      }
      this.setUserData(obj);
    }
  }

  setUserData(userdata): void { // set User data
    this.userDataSubject.next(userdata);
  }

  getUserData() {
    return this.userDataSubject.asObservable();
  };
  sendOtp(data: any) {
    return this.http.post(`${this.apiUrl}sendotp`, data)
  }

  verifyOtp(data: any) {
    return this.http.post(`${this.apiUrl}verifyotp`, data, { withCredentials: true })
  }
  logout(data) {
    return this.http.post(`${this.apiUrl}logout`, data, { withCredentials: true })
  }

  getUserprofileData() {
    return this.http.post(`${this.apiUrl}getUserprofileData`, {})
  }


  getDistrictData() {
    return this.http.post<any>(this.apiUrl + `/getDistrictData`, {});
  }
  getUlbData(data) {
    return this.http.post<any>(this.apiUrl + `/getUlbData`, data);
  }
  getulbbasedSlfData(data) {
    return this.http.post<any>(this.apiUrl + `getulbbasedSlfData`, data);
  }

  getShgGropsReport(data) {
    return this.http.post<any>(this.apiUrl + `getSlfbasedShgData`, data);
  }
  getShgbasedmembersData(data) {
    return this.http.post<any>(this.apiUrl + `getShgbasedmembersData`, data);
  }

  submitRegistrationDetails(data) {
    return this.http.post<any>(this.apiUrl + `submitRegistrationDetails`, data);
  }

  sendRegistarOtp(data) {
    return this.http.post<any>(this.apiUrl + `sendRegistarOtp`, data);
  }
  getJobslist(obj) {
    return this.http.post<any>(this.apiUrl + `getJobslist`, obj);
  }

  getMelaNotifications() {
    return this.http.post<any>(this.apiUrl + `getMelaNotifications`, {});
  }


  submitJobApplicationDetails(data) {
    return this.http.post<any>(this.apiUrl + `submitJobApplicationDetails`, data);

  }

  updatePaymetStatus(data) {
    return this.http.post<any>(this.apiUrl + `updatePaymetStatus`, data);
  }
  getUserAppliedApplications() {
    return this.http.post<any>(this.apiUrl + `getUserAppliedApplications`, {});

  }

  getUserprofileQrData(data) {
    return this.http.post(`${this.apiUrl}getUserprofileQrData`, data)
  }

  getUserAppliedQrApplications(data) {
    return this.http.post<any>(this.apiUrl + `getUserAppliedQrApplications`, data);

  }

  getUserAdmitCard(data) {
    return this.http.post(`${this.apiUrl}getUserAdmitCard`, data)
  }


































  private decodeJWT(token: string): any {
    try {
      const base64Url = token?.split('.')[1]; // Extract the payload part
      const base64 = base64Url?.replace(/-/g, '+').replace(/_/g, '/'); // Convert to Base64
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
          .join('')
      );
      return JSON.parse(jsonPayload); // Parse the payload as JSON
    } catch (error) {
      console.error('Invalid JWT Token', error);
      return null;
    }
  }
}
